import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Typography } from '@mui/material'
import LocalParkingOutlinedIcon from '@mui/icons-material/LocalParkingOutlined'
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined'
import { colors } from '../../const/colors'
import { IOrigoAccount } from '../../graphql/hid/getOrigoAccount'

const ICON_BOX_SX = {
  width: 34,
  height: 34,
  borderRadius: '10px',
  background: 'rgba(19,54,73,0.07)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: colors.navy,
  flexShrink: 0,
} as const

const ActiveBadge = ({ active }: { active: boolean }) => (
  <Box
    data-e2e="parking-access-status"
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '5px',
      px: '10px',
      py: '4px',
      borderRadius: '9px',
      background: active ? colors.greenBg : colors.bg,
    }}
  >
    <Box
      sx={{
        width: 6,
        height: 6,
        borderRadius: '50%',
        background: active ? colors.green : colors.slate,
        flexShrink: 0,
      }}
    />
    <Typography
      sx={{
        fontSize: '12.5px',
        fontWeight: 700,
        color: active ? colors.greenBgText : colors.slate,
      }}
    >
      {active ? 'Aktywne' : 'Nieaktywne'}
    </Typography>
  </Box>
)

const SettingRow = ({
  icon,
  label,
  right,
}: {
  icon: React.ReactNode
  label: string
  right: React.ReactNode
}) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
    }}
  >
    <Box sx={ICON_BOX_SX}>{icon}</Box>
    <Typography
      sx={{
        fontSize: '14px',
        fontWeight: 600,
        color: colors.navy,
        flex: 1,
      }}
    >
      {label}
    </Typography>
    {right}
  </Box>
)

const HIDCardSettings = ({ account }: { account: IOrigoAccount }) => {
  const { t } = useTranslation(['hid', 'user_details'])

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      <SettingRow
        icon={<LocalParkingOutlinedIcon sx={{ fontSize: 18 }} />}
        label={t('parking_access')}
        right={<ActiveBadge active={account.withParkingAccess} />}
      />
      {account.withCarPlate && (
        <SettingRow
          icon={<DirectionsCarOutlinedIcon sx={{ fontSize: 18 }} />}
          label={t('user_details:car_plate')}
          right={
            <Typography
              data-e2e="mobile-card-car-plate-value"
              sx={{
                fontSize: '13px',
                fontWeight: 700,
                color: colors.navy,
                fontFamily: 'monospace',
                letterSpacing: '0.06em',
              }}
            >
              {account.withCarPlate}
            </Typography>
          }
        />
      )}
    </Box>
  )
}

export default HIDCardSettings
